module.exports = __webpack_public_path__ + "static/media/XLS.812f9434.svg";